import { useImpersonation } from "@/contexts/ImpersonationContext";
import { UserAccountsTable } from "@/components/settings/UserAccountsTable";
import { SrIcon } from "@/components/ui/SrIcon";

export default function BrukereSettings() {
  const { activeUser } = useImpersonation();
  const canManageSettings =
    activeUser?.role === "admin" || activeUser?.role === "superadmin";

  if (!canManageSettings) {
    return (
      <div className="page-container">
        <p className="text-sm text-muted-foreground">Du har ikke tilgang.</p>
      </div>
    );
  }

  return (
    <div className="page-container animate-fade-in space-y-6">
      <div>
        <h1 className="font-display font-semibold text-[clamp(28px,3vw,40px)] tracking-[-0.01em] flex items-center gap-2">
          <SrIcon name="users" className="h-6 w-6" />
          Brukere
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Alle kontoer som kan logge inn — ansatte, utviklere og eksterne. Styr
          systemrolle, aktiv/inaktiv status og passordreset her. Ansatt-faglige
          felter administreres på ansattprofilen.
        </p>
      </div>
      <UserAccountsTable />
    </div>
  );
}
